import React, { ReactNode } from "react";
import "./FormGroup.css";

export const FormGroup = ({
  children,
  className = null,
}: {
  children: ReactNode;
  className?: string | null;
}) => (
  <div className={["FormGroup", className].filter((c) => !!c).join(" ")}>
    {children}
  </div>
);

export default FormGroup;
